import React from 'react';
import styles from './style.module.scss';
import { Text, TextName } from 'sdk/text/Text';
import soundscapeZone from './assets/soundscape-zone.svg';

interface SoundscapeGradientCardProps {
  children?: React.ReactNode;
}

const SoundscapeGradientCard: React.FC<SoundscapeGradientCardProps> = ({ children }) => {
  return (
    <div className={styles.container}>
      {children || (
        <>
          <img src={soundscapeZone} alt="Soundscape Zone" className={styles.logo} />
          <div className={styles.divider} />
          <Text type={TextName.Text}>
            A premium audio experience with no additional component costs or speaker redesign required
          </Text>
        </>
      )}
    </div>
  );
};

export default SoundscapeGradientCard;
